export default function debounceAsync(fn, delay = 1000) {
  let timeout = null;
  let resolves = [];

  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      let result = fn(...args);
      resolves.forEach(r => r(result));
      resolves = [];
    }, delay);

    return new Promise(r => resolves.push(r));
  };
}
